import React, { useCallback, memo } from 'react';
import { Table, Popconfirm, message } from 'antd';
import Column from 'antd/lib/table/Column';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Card from '../../../components/Card';
import { api } from '../../../utils/api';
import { ProfileMap, useUser } from '../../../utils/profile';
import { compareProfile } from '../util';
import { Action } from './style';

export default memo(({ users, loading, onDelete, onEditClicked }) => {
  const user = useUser();

  const deleteStore = useCallback(async (user) => {
    try {
      message.loading({
        content: 'Removendo usuário...',
        key: 'remove-user',
      });

      await api.delete(`/user/${user._id}`);

      onDelete(user);

      message.success({
        content: 'Removido com sucesso',
        key: 'remove-user',
        duration: 3,
      });
    } catch (e) {
      message.error({
        content: 'Erro ao remover loja',
        key: 'remove-user',
        duration: 3,
      });
    }
  }, [onDelete]);

  return (
    <Card mode="table">
      <Table dataSource={users} loading={loading} rowKey="_id">
        <Column title="Nome" key="name" dataIndex="name" />
        <Column title="E-mail" key="email" dataIndex="email" />
        <Column title="Loja" key="store.name" dataIndex={["store", "name"]} />
        <Column title="Perfil" key="profile" dataIndex="profile" render={(item) => ProfileMap[item]} />
        <Column align="right" title="" key="x" dataIndex="" render={(item) => (
          <>
            <Popconfirm
              title={`Deseja mesmo remover o usuário '${item.name}'?`}
              okText="Sim"
              cancelText="Não"
              onConfirm={() => deleteStore(item)}
              placement="left"
            >
              <Action disabled={compareProfile(user.profile, item.profile) < 0} icon={<DeleteOutlined />} />
            </Popconfirm>
            <Action disabled={compareProfile(user.profile, item.profile) < 0} icon={<EditOutlined />} onClick={() => onEditClicked(item)} />
          </>
        )} />
      </Table>
    </Card>
  );
});